export default __webpack_public_path__ + "static/media/propuestaGasUnica.c345f0f9.svg";